import type { User } from 'hb-react/types';

export const getNewsIndexPath = ({
  currentUser,
  topicId,
}: {
  currentUser?: User | null;
  topicId?: number;
} = {}) => {
  if (topicId) {
    if (currentUser) {
      return Routes.private_frontoffice_topics_news_index_path(topicId);
    }

    return Routes.private_publicoffice_topics_news_index_path(topicId);
  }

  if (currentUser) {
    return Routes.private_frontoffice_news_index_path();
  }

  return Routes.private_publicoffice_news_index_path();
};
